import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Optional,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormGroupDirective, NgForm, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { ItemFactory } from '../../interfaces/form-controls';
import { ErrorRepeatedControlDirective } from '../error-repeated-control.component';

@Component({
  selector: 'forms-va-input-repeated',
  templateUrl: './input-repeated-glxy.component.html',
  styleUrls: ['./input-repeated-glxy.component.scss'],
  standalone: false,
})
export class GlxyInputRepeatedComponent extends ErrorRepeatedControlDirective {
  @Input() controlArray: UntypedFormArray;
  @Input() addText = 'FRONTEND.FORMS.INPUT.ADD_FIELD';
  @Input() tooltip: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() disableAdd = false;
  @Input() maxFields: number;
  @Input() itemFactory: ItemFactory;
  @Input() bottomSpacing?: 'default' | 'small' | 'none' | false = 'default';
  @Input() buttonPosition?: 'bottom' | 'top' | false = 'bottom';
  @Input() minOneRequired = false;
  @Output() removeClicked = new EventEmitter<string>();

  @ViewChildren('input') inputs: QueryList<ElementRef>;

  constructor(
    private fb: UntypedFormBuilder,
    @Optional() _parentForm: NgForm,
    @Optional() _parentFormGroup: FormGroupDirective,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super(_parentForm, _parentFormGroup);
  }

  add(): void {
    if (this.controlArray.length >= this.maxFields) {
      return;
    }
    if (this.itemFactory) {
      if (this.buttonPosition === 'top') {
        this.controlArray.insert(0, this.itemFactory());
        this.changeDetectorRef.detectChanges();
        this.inputs.first.nativeElement.focus();
      } else {
        this.controlArray.push(this.itemFactory());
        this.changeDetectorRef.detectChanges();
        this.inputs.last.nativeElement.focus();
      }
    } else {
      if (this.buttonPosition === 'top') {
        this.controlArray.insert(0, this.fb.control('', this.controlArray.at(0).validator));
        this.changeDetectorRef.detectChanges();
        this.inputs.first.nativeElement.focus();
      } else {
        this.controlArray.push(this.fb.control('', this.controlArray.at(0).validator));
        this.changeDetectorRef.detectChanges();
        this.inputs.last.nativeElement.focus();
      }
    }
  }

  remove(idx: number): void {
    if (this.controlArray?.at(idx)?.value) {
      this.removeClicked.emit(this.controlArray.at(idx).value);
    }
    this.controlArray.removeAt(idx);
    this.controlArray.markAsDirty();
  }

  showAddAction(): boolean {
    return this.maxFields > 1 && this.controlArray.length < this.maxFields && !this.disableAdd;
  }
}
